import { render } from "./Staff.vue?vue&type=template&id=c92cdf04&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=c92cdf04&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c92cdf04"

export default script